import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export function selectIsPanorama(state: TApplicationState): boolean {
  return state.panorama.status !== null;
}
